import React from "react";
import Container from "../Container";
import { ContentAndQuote } from "../ContentAndQuote";
import Section from "../Section";

export const ContentAndQuoteFlexi = ({ content, source }) => {
  return (
    <Section>
      <Container>
        <ContentAndQuote content={content} source={source} />
      </Container>
    </Section>
  );
};
